export const normalize = (cpf) => cpf.replace(/\D/g, "");
